import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=1c3a99ee&scoped=true&"
import script from "./BackBtn.vue?vue&type=script&lang=js&"
export * from "./BackBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a99ee",
  null
  
)

export default component.exports